import { gql, TypedDocumentNode } from '@apollo/client'
import { QueryPageableRequest, QueryPageableResponse } from '../../../core/type'
import { Ticket } from '../type/ticket'

export const GetTicketQuery: TypedDocumentNode<
  QueryPageableResponse<Ticket, 'ticketsFind'>,
  QueryPageableRequest
> = gql`
    query GetTicketQuery($request: PageableRequest!) {
        ticketsFind(request: $request) {
            data {
                id
                createdAt
                updatedAt
                email
                firstName
                lastName
                description
                imageId
                seen
                replied
                category {
                    id
                    title
                }
            }
            count
        }
    }
`

export const GetNewTicketCountQuery: TypedDocumentNode<{ticketsNewCount: number}> = gql`
    query GetTicketCount{
        ticketsNewCount
    }
`

export const SetTicketAsSeenMutation: TypedDocumentNode<void, {id: number}> = gql`
    mutation SetTicketAsSeen($id: Int!) {
        ticketSetAsSeen(id: $id)
    }
`

export const SetTicketAsRepliedMutation: TypedDocumentNode<void, {id: number}> = gql`
    mutation SetTicketAsReplied($id: Int!) {
        ticketSetAsReplied(id: $id)
    }
`

export type TicketSendEmailInput = {
  ticketId: number
  subject?: string
  text: string
  attachments?: string[]
}

export const TicketSendEmail: TypedDocumentNode<void, {input: TicketSendEmailInput}> = gql`
    mutation TicketSendEmail($input: TicketSendEmailInput!) {
        ticketSendEmail(input: $input)
    }
`

